export default __webpack_public_path__ + "static/media/blue-cog.06a32816.svg";